import { TextField, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { confirmUserPasswordRecovery, updatePasswordRecovery } from 'lib/api';
import EnhancedBox from 'lib/designSystem/BigBox';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

interface User {
  id?: number;
  pendingPasswordReset?: boolean;
  email?: string;
  name?: string;
}

interface ConfirmUserPasswordRecoveryResponse {
  clientId: string;
  message: string;
  success: boolean;
  user: User;
}

interface UpdatePasswordRecoveryResponse {
  success: boolean;
  backUrl?: string | null;
  message?: string;
}

const PasswordRecoveryLanding = () => {
  const [loading, setLoading] = useState(true);
  const { code } = useParams<{ code: string }>();
  const [error, setError] = useState(false);
  const [user, setUser] = useState<User>({});
  const [registerData, setRgisterData] = useState({
    email: '',
    password: '',
    checkPassword: '',
    name: '',
    identifier: '',
    companyName: '',
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setRgisterData({ ...registerData, [e.target.id]: e.target.value });
  };

  const confirmCodeUser = async () => {
    try {
      setLoading(true);
      const response: ConfirmUserPasswordRecoveryResponse =
        await confirmUserPasswordRecovery({ code });
      if (!response.success) setError(true);
      setUser(response.user);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const checkPassword = () => {
    if (registerData.password === registerData.checkPassword) {
      return true;
    }
    return false;
  };

  const checkPasswordLength = () => {
    if (registerData.password.length >= 12) {
      return true;
    }
    return false;
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    try {
      e.preventDefault();
      setLoading(true);
      const response: UpdatePasswordRecoveryResponse =
        await updatePasswordRecovery({
          code,
          password: registerData.password,
        });
      if (!response.success) {
        setError(true);
      }
      if (response?.backUrl != null && response.backUrl.trim() !== '') {
        window.location.href = response.backUrl;
      } else {
        window.location.href = `/`;
      }
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    void confirmCodeUser();
  }, []);

  if (loading) return <CenteredCircularProgress type="noLayout" />;

  if (error) return <div>Hubo un error</div>;

  return (
    <div style={{ backgroundColor: '#F8FAFC', height: '100vh' }}>
      <div style={{ margin: 'auto', maxWidth: '40%', padding: 40 }}>
        <EnhancedBox>
          <Typography variant="h4">Recuperar constraseña</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body1">
                Bienvenido {user.name}, ingresa tu nueva contraseña.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Contraseña"
                fullWidth
                type="password"
                variant="outlined"
                value={registerData.password}
                onChange={(e) => handleChange(e)}
                id="password"
                autoComplete="new-password"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Repetir contraseña"
                fullWidth
                type="password"
                variant="outlined"
                value={registerData.checkPassword}
                onChange={(e) => handleChange(e)}
                id="checkPassword"
                autoComplete="new-password"
              />
              {checkPassword() ? null : (
                <Typography variant="body1" color="error">
                  Las contraseñas no coinciden
                </Typography>
              )}
              {checkPasswordLength() ? null : (
                <Typography variant="body1" color="error">
                  Las contraseñas debe ser mayor a 12 caracteres
                </Typography>
              )}
            </Grid>
          </Grid>
          <Box sx={{ mt: 2 }}>
            <CustomButton
              onClick={(e) => handleSubmit(e)}
              fullWidth
              color="primary"
              variant="contained"
              disabled={!checkPassword() || !checkPasswordLength()}
            >
              Cambiar contraseña
            </CustomButton>
          </Box>
        </EnhancedBox>
      </div>
    </div>
  );
};

export default PasswordRecoveryLanding;
